import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material";

export interface MessageDialogData {
  type: string;
  title: string;
  message: string;
  secondMsg: string
}

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.css']
})
export class MessageDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: MessageDialogData) {}
}
